module.exports = __webpack_public_path__ + "img/hr-green-asterisk-05.9a819999.png";